import { render, staticRenderFns } from "./app-warehouse-comp.vue?vue&type=template&id=5d8b3c5a&"
import script from "./js/app-warehouse-comp.js?vue&type=script&lang=js&"
export * from "./js/app-warehouse-comp.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports